import React, { useRef, useMemo, useState, useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Details, Search, TableHeader } from '@/components'
import { dealsPath, makeSearchPath, sort } from '@/utils'
import { DataType, OrderType } from '@/types'
import { t } from '@/i18n'

const columns: Column[] = [
  {
    key: 'id',
    sortKey: 'id',
  },
  {
    key: 'start_date',
    sortKey: 'startDate',
    dataType: 'date',
  },
  {
    key: 'status',
    sortKey: 'status',
  },
]

import MovementsHistory from './components/movementsHistory'
import UpdateHistory from './components/updatesHistory'
import DealsInfo from './components/dealsInfo'
import DealsRow from './components/dealsRow'
import EditDeal from './components/EditDeal'
import { useSelect } from './onSelect'
import { useData } from './useData'
import { Column } from '@/components/TableHeader'

const Deals: React.FC = () => {
  const navigate = useNavigate()
  const { id, customerId } = useParams()
  const [sortKey, setKey] = useState<string>()
  const [dataType, seDataType] = useState<DataType>()
  const [visible, setVisible] = useState(false)
  const [orderBy, setOrderBy] = useState<OrderType>()
  const _customerId = useMemo(
    () => (customerId === 'customer' ? undefined : Number(customerId)),
    [customerId],
  )
  const { data, loading, onSearch, onFetchMore, pageInfo } =
    useSelect(_customerId)
  const historyRef = useRef<React.ElementRef<typeof UpdateHistory>>(null)
  const movementsRef = useRef<React.ElementRef<typeof MovementsHistory>>(null)
  const { data: selectedData, loading: dealLoading } = useData({ id })

  const sortingBy = useCallback(
    (key?: string, by?: OrderType, dataType?: DataType) => {
      setKey(key)
      seDataType(dataType)
      setOrderBy(by)
    },
    [],
  )

  const HeaderComponent = useMemo(
    () => <Search onSearch={onSearch} />,
    [onSearch],
  )

  const onClose = useCallback(() => {
    navigate(makeSearchPath(dealsPath, { customerId: _customerId }))
  }, [navigate, _customerId])

  return (
    <>
      <div className="row">
        <div className={`col w-${!id ? '100' : '45'}`}>
          <Details
            showNoData
            Row={DealsRow}
            Wrapper="table"
            RowParent="tbody"
            loading={loading}
            TitleWrapper="h4"
            title={t('deals')}
            onFetchMore={onFetchMore}
            listWrapperClassName="list-items"
            wrapperClassName="info-box w-100"
            HeaderComponent={HeaderComponent}
            dataBoxWrapperClassName="info-table"
            fetchMoreStatus={pageInfo.fetchMoreStatus}
            data={[...data].sort((a, b) =>
              sort(a, b, sortKey, orderBy, dataType),
            )}
            Header={() => (
              <TableHeader
                columns={columns}
                onSort={sortingBy}
                orderedBy={orderBy}
              />
            )}
          />
        </div>
        <div className="col w-55">
          <DealsInfo
            onClose={onClose}
            loading={dealLoading}
            onEdit={bool => setVisible(true)}
            node={visible || !id ? undefined : selectedData}
            onHistory={bool => historyRef.current?.showHide(bool)}
          />
          <EditDeal
            visible={visible}
            node={selectedData}
            onClose={() => setVisible(false)}
          />
        </div>
      </div>
      <UpdateHistory
        ref={historyRef}
        id={selectedData?.id}
        onRowClick={() => undefined}
        // onRowClick={() => movementsRef.current?.open()}
      />
      {/* <MovementsHistory ref={movementsRef} /> */}
    </>
  )
}

export default Deals
